<!-- main app container -->
<ngx-loading-bar [includeSpinner]='false' height='3px' color="#FF4961"></ngx-loading-bar>
<!-- <app-alert></app-alert> -->
<router-outlet *ngIf="showContent"></router-outlet>
<ifcs-loading></ifcs-loading>
<p-toast position="top-right" key="alertModal" baseZIndex="999"></p-toast>
<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-secondary" icon="pi pi-exclamation-triangle"
                 acceptLabel="{{'confirm' | translate}}" rejectLabel="{{'cancel' | translate}}">
</p-confirmDialog>
